import { IconArrowForward } from '@capitalise/ui-design-system';
import ImageTitleDescription from 'components/ImageTitleDescription';
import Welcome from 'modules/Onboarding/components/Welcome';
import FundingInstantOffers from 'assets/svgs/funding-instant-offers.svg';

export default ({ completeOnboarding, goToRoute, searchId }) => [
  {
    label: 'Welcome',
    lead: 'We’re excited to have you onboard, because together we can build a better future for SMEs!',
    title: 'Welcome to Capitalise!',
    component: Welcome,
    iconButton: null,
    nextButtonLabel: 'Continue to onboarding',
  },
  {
    lead: 'Capitalise makes it easy to find, compare and select lenders who match your business profile.',
    nextButtonAction: () => {
      completeOnboarding();
      goToRoute(searchId ? `/funding/search/${searchId}/profile` : '/business/today');
    },
    nextButtonLabel: 'Done',
    label: 'Find funding',
    title: 'Find funding for your business',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: FundingInstantOffers,
    iconButton: IconArrowForward,
    isLastStep: true,
  },
];
